/* globals __DEV__ */
import Phaser from 'phaser';

import { rng, effects } from '../effects';

export default class extends Phaser.State {
  init() {
    this.style = {
      font: 'Lora',
      fill: 'black',
      align: 'left'
    };
  }

  create() {

    this.game.physics.startSystem(Phaser.Physics.P2JS);
    this.game.renderer.renderSession.roundPixels = true;

    this.letters = this.game.add.group();
    this.renderWithEffect(this.game.effect);
  }

  renderWithEffect(effect) {
    const t = document.getElementById('text');
    const textNodes = textNodesUnder(t);
    const range = document.createRange();

    const collisions = this.game.physics.p2.createCollisionGroup();
    const worldMaterial = game.physics.p2.createMaterial('worldMaterial');
    game.physics.p2.setWorldMaterial(worldMaterial, true, true, true, true);

    for (let node of textNodes) {
      const computedStyle = window.getComputedStyle(node.parentNode);
      const fontSize = computedStyle.getPropertyValue("font-size");
      const style = {
        fontSize,
        font: 'Lora'
      };
      for (let i = 1; i < node.textContent.length + 1; i++) {
        range.setStart(node, i - 1);
        range.setEnd(node, i);

        if (range.toString() !== ' ' && range.toString() !== '\n') {
          // Skip rendering whitespace
          let rect = range.getBoundingClientRect();
          // Make not relative to scroll pos
          rect.x += window.scrollX;
          rect.y += window.scrollY;

          let text = this.game.add.text(rect.x, rect.y, range.toString(), style);
          this.game.physics.p2.enable(text);
          text.body.x += text.width / 2;
          text.body.y += text.height / 2;
          text.body.clearShapes();

          text.body.damping = rng(0.7, 0.9);

          text.body.static = true;
          let textMaterial = this.game.physics.p2.createMaterial('textMateral', text.body);
          let contact = game.physics.p2.createContactMaterial(textMaterial, worldMaterial);

          const opts = {
            index: i,
            rate: i / rng(250, 1000),
            collisions: collisions,
            material: contact,
            x: rect.x,
            y: rect.y,
            width: this.game.width,
            height: this.game.height
          };
          text.body.static = false;
          effect(text, opts);
          this.letters.add(text);
        }
      }
    }
  }
}

function textNodesUnder(el) {
  var n,
      a = [],
      walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
  while (n = walk.nextNode()) a.push(n);
  return a;
}


//////////////////
// WEBPACK FOOTER
// ./src/states/Game.js
// module id = 338
// module chunks = 0